export default function FilterBox({ children }) {
  return <div className="filter-box">{children}</div>;
}
